
import React from "react";

export default function SuccessModel({ onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg text-center shadow-lg">
        <div className="flex justify-center mb-4">
          <div className="bg-red-500 text-white rounded-full w-12 h-12 flex items-center justify-center text-3xl">
            ✔
          </div>
        </div>
        <p className="text-lg font-normal w-52 p-2 ">
          Unit to SAC Added Successfully!!! ✅
        </p>
        <button
          className="bg-red-600 text-white px-6 py-2 mt-4 rounded hover:bg-red-700"
          onClick={onClose}
        >
          Done
        </button>
      </div>
    </div> 
  );
}
